import { convertToUUID } from 'uuid-encoding';

export default function getBlockKey(block: any) {
  const id = block?.blockId || block?._id;
  const version = block?.blockVersion || block?.version || 0;

  return `a${convertToUUID(id).replace(/-/gi, '_')}${version}`;
}
